import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CustomerLoginRequest } from "src/app/shared/models/DTO/CustomerLoginRequest.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-about-me-validation",
	templateUrl: "./about-me-validation.component.html",
	styleUrls: ["../../../customer.scss"],
})
export class AboutMeValidationComponent implements OnInit {
	@Input() validationCode: string;
	@Input() customerKey: string;
	@Input() awaitValidation: boolean;
	@Output() awaitValidationChange = new EventEmitter<boolean>();
	@Output() validationSuccessChange = new EventEmitter<boolean>();

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async onSignIn() {
		try {
			const loginChallenge: CustomerLoginRequest = {
				validationCode: this.validationCode,
				ck: this.customerKey,
				userAgent: this.app.deviceService.userAgent,
				deviceAgent: this.app.deviceService.device,
			};
			await this.focuslink.customerLoginChallenge(loginChallenge);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Account validated successfully.` });
			this.app.loading(true);
			this.validationSuccessChange.emit(true);
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Sorry, we were unable to validate your request \n${error.error}` });
			this.validationSuccessChange.emit(false);
			this.awaitValidationChange.emit(false);
		}
	}
}
